import { useEffect } from "react"
import queryString from "query-string"

import { useSignInViaReturningHashMutation } from "graphql/mutations/signInViaReturningHash"

function useSignInViaReturningHash() {
  const [signInByHash, { data, loading }] = useSignInViaReturningHashMutation()
  const { hash } = queryString.parse(location.search)

  useEffect(() => {
    if (hash && !Array.isArray(hash)) {
      signInByHash({ variables: { returningHash: hash } })
    }
  }, [])

  return { data, loading }
}

export default useSignInViaReturningHash
